module.exports = __webpack_public_path__ + "static/media/question.cc0a2451.svg";